import { LEAD_STATUSES, type LeadStatusesValues } from "./lead-statuses.ts"

/**
 * The stages `ProjectStatusTransitionService.change_status` accepts, in the
 * order `LIFECYCLE_ORDER` declares them in ezbuild_back. Anything outside this
 * tuple is rejected outright, so offering it as a target guarantees a 400 —
 * while a lead already sitting on one still has to render its status tag.
 * Ordered explicitly: Booked, Exploration and Contract were added after the
 * enum, so numeric order no longer matches lifecycle order.
 */
const LIFECYCLE_STAGES: LeadStatusesValues[] = [
  LEAD_STATUSES.NEW,
  LEAD_STATUSES.CONTACTED,
  LEAD_STATUSES.BOOKED,
  LEAD_STATUSES.EXPLORATION,
  LEAD_STATUSES.ESTIMATE,
  LEAD_STATUSES.CONTRACT,
  LEAD_STATUSES.WON
]

const isLifecycleStage = (status: unknown): status is LeadStatusesValues =>
  LIFECYCLE_STAGES.includes(Number(status) as LeadStatusesValues)

/** Position in the lifecycle, or -1 for a stage outside it. */
const stageIndex = (status: unknown): number =>
  LIFECYCLE_STAGES.indexOf(Number(status) as LeadStatusesValues)

export { LIFECYCLE_STAGES, isLifecycleStage, stageIndex }
